// extracted by mini-css-extract-plugin
export default {"modalWrapper":"styles_modalWrapper__FfSeO"};